import { createSelector } from '@reduxjs/toolkit';
import { snakeToCamelCase } from 'services/helpers';
import { doFilterSetsHaveError } from 'ts-filters/utils';
import UUID from 'utility/UUID';

export const getReasonsDialogData = ({ recordsPage }) => {
  return recordsPage.reasonsDialogData;
};
export const getReasonsDisqualifiedDialogData = ({ recordsPage }) => {
  return recordsPage.reasonsDisqualifiedDialogData;
};
export const getRecordsIsFetchingSelector = ({ recordsPage }) =>
  recordsPage.isFetchingRecords;

export const getNeedToLoadCountsSelector = ({ recordsPage }) =>
  recordsPage.needToLoadCounts;

export const getRecordsIsFilteringSelector = ({ recordsPage }) =>
  recordsPage.isFiltering;

export const getRecordsPageReady = ({ recordsPage }) => recordsPage.pageReady;

export const getFilterGroupReason = ({ recordsPage }) =>
  recordsPage.filterGroupReason;

export const getIsLoadingView = ({ recordsPage }) => recordsPage.isLoadingView;

export const getHasFilterError = (state) => {
  const filters = state.recordsPage.filters.config;
  const errors = state.recordsPage.filters.errors;

  if (!filters || filters.query) {
    return false;
  }

  const errorsWhenLoadingSteps = doFilterSetsHaveError(filters);
  const errorsWhenPerformingSearch = Boolean(
    errors?.parsedErrors.some(Boolean)
  );

  return errorsWhenLoadingSteps || errorsWhenPerformingSearch;
};

export const selectReasonsLostField = (state) => {
  return state.recordsPage.fields.find(
    (field) => field.name === 'reasons_lost'
  );
};

export const selectReasonsDisqualifiedField = (state) => {
  return state.recordsPage.fields.find(
    (field) => field.name === 'reasons_disqualified'
  );
};

const selectDefaultFields = (state) => {
  return state.recordsPage.allFields.filter((field) => {
    return field.isDefault;
  });
};

const selectFieldIdsForMobile = (state) => {
  return state.recordsPage.allFields.reduce((acc, field) => {
    if (
      ['estimated_close_date', 'name', 'owner', 'stage'].includes(field.name)
    ) {
      acc.push(field.id);
    }
    return acc;
  }, []);
};

export const selectColumnFieldIds = createSelector(
  selectFieldIdsForMobile,
  selectDefaultFields,
  (state) => state.recordsPage.pageConfig.columnOrder,
  (state) => state.recordsPage.model,
  (mobileIds, fields, columnOrder, model) => {
    const defaultFieldIds = fields.reduce((acc, field) => {
      acc[snakeToCamelCase(field.name)] = field.id;
      return acc;
    }, {});

    if (columnOrder.length === 0) {
      let columns = [
        'name',
        'owner',
        'created',
        'updated',
        'entityValue',
        'displayName',
      ];

      if (model.objectType === 'pipeline') {
        columns = [
          'name',
          'owner',
          'created',
          'updated',
          'entityValue',
          'stage',
          'estimatedCloseDate',
          'actualCloseDate',
          'percentageChanceToClose',
          'displayName',
        ];
      }

      if (model.meta?.defaultColumns?.length) {
        columns = model.meta.defaultColumns.map((column) => {
          return column.id;
        });
      }

      // there may not be view permissions for a default field
      const ids = columns.reduce((acc, name) => {
        if (defaultFieldIds[name]) {
          acc.push(defaultFieldIds[name]);
        } else if (UUID.validate(name)) {
          acc.push(name);
        }
        return acc;
      }, []);

      return ids;
    }

    // there may not be view permissions for a default field
    const ids = columnOrder.reduce((acc, idOrName) => {
      if (defaultFieldIds[idOrName]) {
        acc.add(defaultFieldIds[idOrName]);
      } else if (UUID.validate(idOrName)) {
        acc.add(idOrName);
      }

      return acc;
    }, new Set(mobileIds));

    return [...ids];
  }
);
